<div>

  <div class="row" *ngIf="showlist">
    <div class="row">
      <div class="col">
        <app-fast-search [appearFastSearch]="false" [appCodes]="[2005,2006,1430,1023]"
          (searchKeys)="onSearchClick($event)" ngDefaultControl>
        </app-fast-search>
      </div>
    </div>
    <p-dataTable id="section" tableStyleClass="table table-bordered table-striped" [value]="PhysiotherapySession"
      [rows]="10" [paginator]="true" [pageLinks]="3" [totalRecords]="totalRecord" [lazy]="true" [globalFilter]="gb"
      [selectionMode]="'multiple'" [rowsPerPageOptions]="[5,10,50,100]">

      <p-column field="code" [style]="{'width': '5%'}" header="{{'PATCODE' | translate }}"> </p-column>
      <p-column field="visitSerial" [style]="{'width': '5%'}" header="{{'VisitCode' | translate }}"> </p-column>

      <p-column field="fullnameAr" [style]="{'width': '30%'}" header="{{'PATNAMEAR' | translate }}"></p-column>
      <p-column field="serviceNameAr" [style]="{'width': '30%'}" header="{{ 'SERVICENAMEAR' | translate }}"> </p-column>
      <p-column width="100" header="{{ 'ACTIONS' | translate }}" [style]="{'width': '5%'}">
        <ng-template pTemplate="options" let-row="rowData">
          <span>
            <icon-action (actionclicked)="onIconActionClick($event,row)" [rowActiveAction]="getActiveAction"
              [rowData]="row" [appCodes]="[2426,2260,2272,2471,6643,333,306,6515,2332,2333,6509,6520,2502,6587,5227]">
            </icon-action>
          </span>

        </ng-template>
      </p-column>
    </p-dataTable>
  </div>
  <div class="full-screen">

    <div class="row" *ngIf="!showlist" class=" col p-1 ui-datatable-tablewrapper">
      <div>
        <breadcrumb [data]="breadCrumbData"></breadcrumb>
        <span class="fas icon-full-screen" [ngClass]="{'fa-compress': fullScreen, 'fa-expand': !fullScreen}"></span>
      </div>

      <!-------------------------------------------------------------------------    -->
      <table class="table table-bordered table-striped">
        <thead class="ui-datatable-thead" style=" height: 60px; ">
          <tr>
            <th style="width:5%">{{'NO.' | translate }}</th>
            <th style="width:10%">{{'SERVICESTEP' | translate }}</th>
            <th style="width:10%">{{'TIME' | translate }}</th>
            <th style="width:10%">المنفذ</th>
            <th style="width:10%">وثائق المرضى</th>
            <th style="width:10%">{{'ROOM' | translate }}</th>
            <th style="width:10%"> بداء المرحله</th>
            <th style="width:10%">المتبقى على انتهاء المرحله</th>
            <th style="width:10%">انتهاء المرحله</th>
            <th style="width:10%">{{'ACTIONS' | translate }}</th>
          </tr>
        </thead>
        <tbody class="ui-datatable-data ui-widget-content">
          <tr *ngFor="let item of PhysiotherapySteps" class="ui-widget-content">
            <td>{{item.serial}}</td>
            <td>{{translate.currentLang == 'ar' ? item.stepNameAr: item.stepNameEn}}</td>
            <td>{{item.timeInMinutes}}</td>
            <td>{{translate.currentLang == 'ar' ? item.docNameAr: item.docNameEn}}</td>
            <td>
              <icon-action (clicked)="onActionIconsClicked($event,row)" [appCodes]="[6500]"></icon-action>
            </td>
            <td>
              <span *ngIf="item.startStageCheck">
                <sanabel-selectize appcode="1057" [SearchKeys]="{LoadCurrentBranchOnly:1}" [simpleView]="true" [(ngModel)]="item.scheduleVplaceID" >
                </sanabel-selectize>
              </span>  
            </td>
            <td>
              <label class="custom-control custom-checkbox pl-0 mb-0">
                <input type="checkbox" class="custom-control-input" [(ngModel)]="item.startStageCheck"
                  (change)="checkboxChanged(item,$event)">
                <span class="custom-control-indicator"></span>
              </label>
            </td>
            <td>{{item.remainingTime}}</td>
            <td>
              <label class="custom-control custom-checkbox pl-0 mb-0">
                <input  type="checkbox" class="custom-control-input" [(ngModel)]="item.endStageCheck"
                  (change)="checkboxChanged(item,$event)" [disabled]="!item.startStageCheck">
                <span class="custom-control-indicator"></span>
              </label>
            </td>
            <td></td>
          </tr>

          <tr class="ui-widget-content">
            <td colspan="3">
              <span style="color: rgb(116, 118, 240);">{{'TOTAL' | translate}}</span>
            </td>
            <td>
              <span style="color: rgb(116, 118, 240);">{{totalTime}}</span>
            </td>
            <td colspan="2">
              <span style="color: rgb(116, 118, 240);">الزمن المنقضى </span>
            </td>
            <td>
              <span style="color: rgb(116, 118, 240);">{{remainingTime}}</span>
            </td>
            <td colspan="2">
              <span style="color: rgb(116, 118, 240);"> المتبقى </span>
            </td>
            <td>
              <span style="color: rgb(116, 118, 240);">{{remaining}}</span>
            </td>
          </tr>
        </tbody>
      </table>

      <div>
        <btns-ctrl #btnCtrl1 [appCodes]="[2260,2]" (clicked)="onBtnsClicked($event)">
        </btns-ctrl>
      </div>
    </div>
  </div>
</div>
<div>
  <block-modal-container #popup>
    <ng-container class="modal-body">
      <div *ngIf="dynamicComponent == 3">
        <sanabel-files-upload [multiple]="true" [approvals]="true" [patientVisitCode]="actionRowData.visitSerial"
          [patientCode]="actionRowData.patCode">
        </sanabel-files-upload>
      </div>
    </ng-container>
  </block-modal-container>
</div>